<template>
  <div class="grid__cell col9-of-12--medium 1col0-of-12--large-up">
    <label>
      Partner Program URL
      <input
        data-hj-allow
        type="text"
        :value="data.partnerProgramUrl"
        placeholder="yourdomain.com/partners"
        @change="
          updateUrl({ value: $event.target.value, key: 'partnerProgramUrl' })
        "
      />
      <p class="help-text">Link to your partner program from the directory.</p>
    </label>

    <label class="url-input">
      PartnerPage URL
      <input
        data-hj-allow
        type="text"
        :value="data.partnerpageUrl"
        @change="
          $emit('url-change', {
            value: $event.target.value,
            key: 'partnerpageUrl',
          })
        "
      />
      <span class="url-input__suffix">.partnerpage.io</span>
      <p class="help-text">Link to your partner program from the directory.</p>
    </label>

    <label>
      Agencies directory custom domain
      <input
        data-hj-allow
        type="text"
        :value="data.customDomain"
        @change="updateUrl({ value: $event.target.value, key: 'customDomain' })"
      />
      <p class="help-text">
        We'll help you with some DNS changes to get it to work.
      </p>
    </label>

    <label>
      Agencies directory page
      <input
        data-hj-allow
        name="directoryPage"
        type="text"
        :value="data.directoryPage"
        placeholder="partner-directory"
        @change="
          updateField({ value: $event.target.value, key: 'directoryPage' })
        "
      />
      <p class="help-text">
        You agencies directory will be located at
        {{ agenciesDirectoryHelpText }}
      </p>
    </label>

    <template v-if="details.integrationsEnabled">
      <label>
        Integrations directory custom domain
        <input
          data-hj-allow
          type="text"
          :value="data.integrationsCustomDomain"
          @change="
            updateUrl({
              value: $event.target.value,
              key: 'integrationsCustomDomain',
            })
          "
        />
        <p class="help-text">
          We'll help you with some DNS changes to get it to work.
        </p>
      </label>

      <label>
        Integrations directory page
        <input
          data-hj-allow
          name="integrationsDirectoryPage"
          type="text"
          :value="data.integrationsDirectoryPage"
          placeholder="integrations-directory"
          @change="
            updateField({
              value: $event.target.value,
              key: 'integrationsDirectoryPage',
            })
          "
        />
        <p class="help-text">
          You integrations directory will be located at
          {{ integrationsDirectoryHelpText }}
        </p>
      </label>
    </template>

    <label>
      Terms of Service page
      <input
        data-hj-allow
        type="text"
        :value="data.termsUrl"
        @change="updateUrl({ value: $event.target.value, key: 'termsUrl' })"
      />
      <p class="help-text">Link to your terms of service page</p>
    </label>

    <label>
      Privacy Policy page
      <input
        data-hj-allow
        type="text"
        :value="data.privacyUrl"
        @change="updateUrl({ value: $event.target.value, key: 'privacyUrl' })"
      />
      <p class="help-text">Link to your privacy policy page.</p>
    </label>
    <template v-if="details.integrationsEnabled">
      <label style="margin-bottom: 0.5rem;">
        Show integration request button?
      </label>
      <div class="radio-btn-field" style="display: flex;">
        <input
          type="radio"
          id="integration-btn-link"
          name="integration-btn-type"
          :value="true"
          v-model="integrationBtnRequest"
        />
        <label
          class="fs-sm"
          style="margin-left: 10px; font-weight: 400; margin-bottom: 0;"
          for="integration-btn-link"
          >Yes</label
        >
      </div>
      <div style="margin-left: 1.75rem">
        <input
          v-if="urlIntRequestButtonActive"
          type="text"
          class="customInput"
          :value="data.integrationsBtnUrl"
          @change="
            updateUrl({ value: $event.target.value, key: 'integrationsBtnUrl' })
          "
          placeholder="Enter the URL for this button - https://request-integration-button.com"
        />
      </div>
      <div
        class="radio-btn-field"
        style="display: flex; margin-top: 0.5rem; margin-bottom: 2rem;"
      >
        <input
          id="integration-btn-disabled"
          type="radio"
          name="integration-btn-type"
          :value="false"
          v-model="integrationBtnRequest"
        />
        <label
          class="fs-sm"
          style="margin-left: 10px; font-weight: 400; margin-bottom: 0;"
          for="integration-btn-disabled"
          >No</label
        >
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    data: Object,
    urlIntRequestButtonActive: Boolean,
  },
  computed: {
    ...mapGetters(['details']),
    agenciesDirectoryHelpText() {
      const page = this.data.directoryPage || '';

      if (this.data.customDomain) {
        return this.data.customDomain + '/' + page;
      } else if (this.data.partnerpageUrl) {
        return `https://${this.data.partnerpageUrl}.partnerpage.io/${page}`;
      } else {
        return `https://acme.partnerpage.io/${page}`;
      }
    },
    integrationsDirectoryHelpText() {
      const page = this.data.integrationsDirectoryPage || '';

      if (this.data.integrationsCustomDomain) {
        return this.data.integrationsCustomDomain + '/' + page;
      } else if (this.data.partnerpageUrl) {
        return `https://${this.data.partnerpageUrl}.partnerpage.io/${page}`;
      } else {
        return `https://acme.partnerpage.io/${page}`;
      }
    },
    integrationBtnRequest: {
      get() {
        return this.$store.getters[`settings/urls/urlIntRequestButtonActive`];
      },
      set(payload) {
        this.$store.commit('settings/urls/setIntRequestButtonActive', payload);
        this.$emit('url-change', { key: 'integrationsBtnUrl', value: '' });
      },
    },
  },
  methods: {
    updateField(payload) {
      this.$emit('url-change', payload);
    },
    updateUrl(payload) {
      this.$emit('url-change', this.checkUrl(payload));
    },
    checkUrl(payload) {
      if (payload.value === '') return payload;
      if (!payload.value.includes('http')) {
        payload.value = 'https://' + payload.value;
      }
      return payload;
    },
  },
};
</script>

<style lang="scss" scoped>
.grid__cell label {
  margin-bottom: 2rem;
}
</style>
